export const getScriptNonce = (): Window['NONCE'] | null =>
  window?.NONCE ?? null
